import React, { useState } from "react";
import "./TableCardSelector.scss";

// A tab can pass `rightElement`; it shows at the right end of the tab row
// while that tab is active (used for the "Tag Files" button on All Files).
export default function TableCardSelector({ tabs }) {
  const [active, setActive] = useState(0);
  const rightElement = tabs[active].rightElement;

  return (
    <div className="data-estate-table-container">
      <div
        className="tab-header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <div className="tab-toggle">
          {tabs.map((tab, index) => (
            <div key={tab.name} className="toggle-wrapper">
              <button
                className={`toggle-item ${active === index ? "active" : ""}`}
                onClick={() => setActive(index)}
              >
                {tab.name}
              </button>
              {index !== tabs.length - 1 && <div className="data-estate-divider" />}
            </div>
          ))}
        </div>
        {rightElement && <div className="tab-header-right">{rightElement}</div>}
      </div>
      <div className="tab-content">{tabs[active].component}</div>
    </div>
  );
}